import React from "react";
import styled from "styled-components";

import { translations } from "../../../utils/translations.js";
import { useSelector } from "react-redux";

const Wrapper = styled.div`
  height: 100%;
  width: 75%;
  display: flex;
  align-items: flex-start;
  flex-direction: row;
  justify-content: space-between;
  flex-direction: column;
  @media (max-width: 768px) {
    overflow-x: auto; /* Permite derularea pe orizontală */

    padding: 1rem;
  }
`;

const PageTitle = styled.h2`
  color: var(--secondary-font-color);
  text-align: center;
  font-family: Georgia, serif;
  width: 75%;
`;

const SubTitle = styled.h3`
  color: var(--secondary-font-color);
  font-family: Georgia, serif;
  width: 100%;
`;

const Text = styled.p`
  color: var(--secondary-font-color);
  text-align: justify;
  font-family: Verdana, sans-serif;
  width: 90%;
  @media (max-width: 768px) {
    width: 100%; /* Pe mobil, ocupă întreaga lățime */
  }
`;

const List = styled.ul`
  color: var(--secondary-font-color);
  font-family: Verdana, sans-serif;
  width: 90%;
  @media (max-width: 768px) {
    width: 100%;
  }
`;

const BoldText = styled.div`
  color: var(--secondary-font-color);
  font-family: Verdana, sans-serif;
  width: 90%;
  font-weight: bold;
`;

const TextSection = styled.div`
  color: var(--secondary-font-color);
  font-family: Verdana, sans-serif;
  width: 90%;
  @media (max-width: 768px) {
    width: 100%;
  }
`;

const TransportPage = () => {
  const languageCode = useSelector((state) => state.settings.languageCode);
  if (languageCode === "ro")
    return (
      <Wrapper>
        <PageTitle>
          {translations[languageCode]["footer-pay-section"]}
        </PageTitle>
        <SubTitle>
          {translations[languageCode]["transport-page-subtitle"]}
        </SubTitle>
        <TextSection>
          <Text>
            Transportul produselor se face contra cost, prin firma de curierat
            Sameday sau personal la o adresă din zona de livrare gratuită.
            Contravaloarea costului de transport este suportată exclusiv de
            către client, în funcție de prețul impus de firma de curierat, fără
            orice fel de adaosuri din partea FiloPrint. Durata de manufacturare
            și livrare este între 3 și 7 zile lucrătoare. Dacă te afli în Zona
            de Livrare Gratuită, livrarea se face personal de către FiloPrint,
            fără costuri adiționale.
          </Text>
          <Text>
            Zona de Livrare Gratuită:
            <List>
              <li>Sector 6, București</li>
           
            </List>
          </Text>
              <Text>
            Zona de ridicare personală:
            <List>
              <li>Bd Timisoara 101T, Sector 6, București</li>
            </List>
          </Text>
        </TextSection>

        <SubTitle>{translations[languageCode]["pay-page-subtitle"]}</SubTitle>
        <Text>
          Puteți achiziționa produsele de pe site-ul nostru utilizând
          următoarele metode de plată:
        </Text>

        <TextSection>
          <BoldText> 1. Ramburs (numerar la livrare)</BoldText>
          <Text>
            Contravaloarea produselor și a serviciilor comandate poate fi
            achitată direct curierului, în momentul livrării, la adresa
            specificată de dumneavoastră.
          </Text>
          <BoldText> 2. Plată cu card bancar direct pe site</BoldText>
          <Text>
            Pentru plățile efectuate cu carduri de credit sau debit emise sub
            sigla Visa și MasterCard (Visa/Visa Electron, Mastercard/Maestro),
            utilizăm sistemul de plată securizat oferit de Banca Transilvania.
            Acest sistem garantează un nivel ridicat de securitate. Se pot
            efectua plăți online cu orice card Visa sau MasterCard, inclusiv
            carduri de debit, electronice (Maestro, Visa Electron) și carduri
            virtuale emise de aceste organizații.
          </Text>
          <BoldText> 3. Transfer bancar </BoldText>
          <Text>
            Plata poate fi efectuată și prin transfer bancar, pe baza unei
            facturi proforme. Livrarea produselor se va realiza după confirmarea
            intrării sumei corespunzătoare în contul nostru. Dacă alegeți să
            plătiți prin transfer bancar vă rugăm să ne contactați înainte prin
            email sau la telefon.
          </Text>
          <Text>
            Detalii pentru plata prin transfer bancar:
            <List>
              <li>
                <strong>Beneficiar:</strong> FILOPRINT S.R.L.
              </li>
              <li>
                <strong>Cod unic de identificare (CUI):</strong> 43031922
              </li>
              <li>
                <strong>Număr de înregistrare la Registrul Comerțului:</strong>{" "}
                J15/937/10.09.2020
              </li>
              <li>
                <strong>Adresă sediu social:</strong> Strada Liliacului, Nr. 9,
                Doicești, Dâmbovița
              </li>
              <li>
                <strong>Banca:</strong> Banca Transilvania
              </li>
              <li>
                <strong>IBAN (Lei):</strong> RO86BTRLRONCRT0566636801
              </li>
            </List>
          </Text>
        </TextSection>
      </Wrapper>
    );
  else
    return (
      <Wrapper>
        <PageTitle>
          {translations[languageCode]["footer-pay-section"]}
        </PageTitle>
        <SubTitle>
          {translations[languageCode]["transport-page-subtitle"]}
        </SubTitle>
        <TextSection>
          <Text>
            The transport of products is done at a cost, via the Sameday courier
            company or personally to an address within the free delivery zone.
            The transport cost is fully covered by the customer, according to
            the price set by the courier company, with no additional charges
            from FiloPrint. The manufacturing and delivery time is between 3 and
            7 working days. If you are in the Free Delivery Zone, the delivery
            is made personally by FiloPrint, with no additional costs.
          </Text>
          <Text>
            Free Delivery Zone:
            <List>
              <li>Sector 6, Bucharest</li>
            
            </List>
          </Text>

           <Text>
           Free Pickup Zone:
            <List>
              <li>Bd Timisoara 101T, Sector 6, București</li>
            </List>
          </Text>
        </TextSection>

        <SubTitle>{translations[languageCode]["pay-page-subtitle"]}</SubTitle>
        <Text>
          You can purchase products from our website using the following payment
          methods:
        </Text>

        <TextSection>
          <BoldText>1. Cash on Delivery</BoldText>
          <Text>
            The value of the products and services ordered can be paid directly
            to the courier upon delivery, at the address you specify.
          </Text>
          <BoldText>2. Payment by Credit Card on the Website</BoldText>
          <Text>
            For payments made with credit or debit cards issued under the Visa
            and MasterCard brands (Visa/Visa Electron, Mastercard/Maestro), we
            use the secure payment system provided by Banca Transilvania. This
            system ensures a high level of security. Payments can be made online
            with any Visa or MasterCard, including debit cards, electronic cards
            (Maestro, Visa Electron), and virtual cards issued by these
            organizations.
          </Text>
          <BoldText>3. Bank Transfer</BoldText>
          <Text>
            Payment can also be made by bank transfer, based on a proforma
            invoice. The delivery of the products will take place after the
            corresponding amount has been confirmed in our account. If you
            choose to pay by transfer please contact us by phone or email.
          </Text>
          <Text>
            Bank transfer payment details:
            <List>
              <li>
                <strong>Beneficiary:</strong> FILOPRINT S.R.L.
              </li>
              <li>
                <strong>Unique Identification Code (CUI):</strong> 43031922
              </li>
              <li>
                <strong>Registration Number at the Trade Register:</strong>{" "}
                J15/937/10.09.2020
              </li>
              <li>
                <strong>Registered Office Address:</strong> Strada Liliacului,
                Nr. 9, Doicești, Dâmbovița
              </li>
              <li>
                <strong>Bank:</strong> Banca Transilvania
              </li>
              <li>
                <strong>IBAN (Lei):</strong> RO86BTRLRONCRT0566636801
              </li>
            </List>
          </Text>
        </TextSection>
      </Wrapper>
    );
};

export default TransportPage;
